import { armsTheWeb } from "@rally/agreed";

export function cannotSearchYet(input: { capabilities: readonly string[]; searchKeys: number }): boolean {
  return armsTheWeb(input.capabilities) && input.searchKeys === 0;
}
